import { render, staticRenderFns } from "./MList.vue?vue&type=template&id=0aadc860&"
import script from "./MList.ts?vue&type=script&lang=ts&"
export * from "./MList.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports